import { ref } from 'vue'
import { defineStore } from 'pinia'
import {
  doc,
  setDoc,
  onSnapshot,
  type Unsubscribe,
} from 'firebase/firestore'
import { db } from '@/firebase'
import { useSyncStore } from './sync'
import type { OrgAssignment } from '@/types'

export const useOrgAssignmentStore = defineStore('orgAssignment', () => {
  const orgAssignment = ref<OrgAssignment | null>(null)
  const loading = ref(false)

  let unsubFn: Unsubscribe | null = null
  let _incidentId = ''
  let _opId = ''

  function subscribeToOrgAssignment(incidentId: string, opId: string) {
    if (incidentId === _incidentId && opId === _opId && unsubFn) return
    if (unsubFn) unsubFn()
    _incidentId = incidentId
    _opId = opId
    loading.value = true
    unsubFn = onSnapshot(
      doc(db, 'incidents', incidentId, 'operational_periods', opId, 'org_assignment', 'data'),
      (snap) => {
        orgAssignment.value = snap.exists() ? (snap.data() as OrgAssignment) : null
        loading.value = false
      },
    )
  }

  async function saveOrgAssignment(incidentId: string, opId: string, data: Partial<OrgAssignment>) {
    const syncStore = useSyncStore()
    syncStore.pendingWrites++
    try {
      await setDoc(
        doc(db, 'incidents', incidentId, 'operational_periods', opId, 'org_assignment', 'data'),
        data,
        { merge: true },
      )
    } finally {
      syncStore.pendingWrites--
    }
  }

  function teardown() {
    if (unsubFn) { unsubFn(); unsubFn = null }
    _incidentId = ''
    _opId = ''
    orgAssignment.value = null
    loading.value = false
  }

  return { orgAssignment, loading, subscribeToOrgAssignment, saveOrgAssignment, teardown }
})
